import request from '@/utils/request';

export function getReadingDayInfo() {
  return request({
    url: '/Marketing/readingDay',
  });
}

export function getReadingDayGroupList(params) {
  return request({
    url: '/Marketing/readingDayGroupList',
    params,
  });
}

export function getReadingDayAudioList(params) {
  return request({
    url: '/Marketing/readingDayAudioList',
    params,
  });
}

export function getReadingDayProjectList(params) {
  return request({
    url: '/Marketing/readingDayProjectList',
    params,
  });
}

export function readingDayPurchase(data) {
  return request({
    url: '/Marketing/readingDayPurchase',
    method: 'POST',
    data,
  });
}

export function readingDayRemind(data) {
  return request({
    url: '/Marketing/readingDayRemind',
    method: 'POST',
    data,
  });
}
